export const customCheckBox = () => {
    if ($('input[type=checkbox]').length > 0 || $('input[type=radio]').length > 0) {
        $('input[type=checkbox],input[type=radio]').each(function() {
            var $this = $(this),
                thisId = $this.attr("id"),
                $thisLabel = $("label[for='" + thisId + "']"),
                $span = $("label[for='" + thisId + "'] > span"),
                $input = $("label[for='" + thisId + "'] > input");
            if ($thisLabel.length > 0 && !$span.length > 0) $thisLabel.html('<span>' + $thisLabel.html() + '</span>');
            if (!$input.length > 0) $this.insertBefore($("label[for='" + thisId + "'] > span"));
        });
    }
};
